import { HTMLProps, ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  SvgIconProps,
  TypographyProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

import ArchivedIcon from './ArchivedIcon';
import DraftIcon from './DraftIcon';
import EndedIcon from './EndedIcon';
import Label from './Label';
import LiveIcon from './LiveIcon';
import Root from './Root';
import TransitionIcon from './TransitionIcon';
import { Color } from './types';

const styles = createStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
  },
  icon: {},
  label: {},
});

const ICONS = {
  draft: DraftIcon,
  live: LiveIcon,
  ended: EndedIcon,
  archived: ArchivedIcon,
  transition: TransitionIcon,
  active: LiveIcon,
};

export type CompactComponentProps = Omit<
  HTMLProps<HTMLDivElement>,
  'label' | 'color'
> &
  WithStyles<typeof styles> & {
    className?: string;
    state: keyof typeof ICONS;
    color?: Color;
    error?: boolean;
    progress?: number;
    incomplete?: boolean;
    spinning?: boolean;
    label?: ReactNode;
    typographyProps?: TypographyProps;
    disableTypography?: boolean;
    iconProps?: Omit<SvgIconProps, 'children' | 'color'>;
  };

const CompactComponent = ({
  state,
  color,
  error,
  progress,
  incomplete,
  spinning,
  label,
  typographyProps,
  disableTypography,
  iconProps,
  classes,
  className,
  ...rest
}: CompactComponentProps) => {
  const Icon = ICONS[state];

  return (
    <Root className={classNames(classes.root, className)} {...rest}>
      <Icon
        className={classes.icon}
        color={color}
        error={error}
        progress={progress}
        incomplete={incomplete}
        spinning={spinning}
        fontSize="inherit"
        {...iconProps}
      />
      {label && (
        <Label
          {...typographyProps}
          disableTypography={disableTypography}
          className={classes.label}
        >
          {label}
        </Label>
      )}
    </Root>
  );
};

CompactComponent.displayName = 'StateIcon';

export default withStyles(styles)(CompactComponent);
